import {RumTimeMark, sendRumTimeMark} from '@logistics-frontend/modules/rum'
import {applyPolyfills} from '@logistics-frontend/polyfills'
import {raise} from '@logistics-frontend/utils'
import React from 'react'
import {createRoot} from 'react-dom/client'

import {config} from './config'

sendRumTimeMark(RumTimeMark.BEFORE_JS_FRAMEWORK_INIT)

applyPolyfills()
  .then(() =>
    (config.config.appVersion === '3' ? import('./AppV3@desktop') : import('./AppV2')).then(app => app.default),
  )
  .then(App => ({
    root: createRoot(document.getElementById('tariffs_root') || raise('cant find root element "tariffs_root"')),
    App,
  }))
  .then(({root, App}) => void root.render(<App />))
  .then(() => sendRumTimeMark(RumTimeMark.REACT_INITED))

sendRumTimeMark(RumTimeMark.JS_FRAMEWORK_INITED)
